import getPageNumberFromQuery from "../../query/helpers/getPageNumberFromQuery";

export default state => getPageNumberFromQuery(state.search.query);
